<div [formArrayName]="formIndex">
  <dt-evaluation-checkboxes [prompt]="entry.baseQuestion" [options]="entry.options" [rows]="entry.subQuestions" [values]="[]">
  </dt-evaluation-checkboxes>
</div>
